import { CARD_PROVIDERS } from '@shared/constants/providers/AutomaticCardsProviders';
import {
    oneClickInsightCardValidation,
} from '@domain/_screens/workflow/automatic-card/one-click-insight/one-click-insight.validation';
import { adCreationCardValidation } from '@domain/_screens/workflow/automatic-card/ad-creation/ad-creation.validation';

const validationMethods = {
    [CARD_PROVIDERS.AD_CREATION]: adCreationCardValidation,
    [CARD_PROVIDERS.ONE_CLICK_INSIGHT]: oneClickInsightCardValidation,
};

export const validateAutomaticCard = (card) => {
    const validationMethod = validationMethods[card.provider];

    if (!validationMethod) return;
    validationMethod(card);
};
